import React, { useState,useEffect } from "react";
import { Container, Col,Row, Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../../context/LoginContext";
import { CourseIcon, RegisterUsersIcon, TrainingIcon, CertificateCountIcon,UserIconOutline} from '../../utils/FontIcon';
import apiClient from "../../api/apiClient";
import { GETMETRICS } from '../../utils/ApiEndPoint';
import { TopMenu,SwiperCarousel } from "../shared";
import LiveUserCount from '../shared/Header/LiveUserCount';
import {convertNumberToKM} from '../../utils/utils'

function Home() {
  const navigate = useNavigate();
  const { isLoggedIn } = useLogin();
  const [metricsData, setMetricsData] = useState(null);
  useEffect(() => {
    if (isLoggedIn) {
      navigate("/home");
    }else{
      apiClient.get(GETMETRICS).then((response) => {
        if(response.status === 200){
         setMetricsData(response?.data?.data);
        } else{
          setMetricsData(null);
        }
      }).catch((error) => {
       console.error('Error fetching metrics:', error);
      });
    }
  }, [isLoggedIn]);
  const handelLoginClick = () => {
    navigate("/login");
  };
  const handelAbout = () => {
    navigate("/aboutus");
  };
  const carouselData = [
    {src: "https://pmfby.amnex.co.in/pmfby/lms/1.jpeg", alt: "PMFBY - LMS"},
    {src: "https://pmfby.amnex.co.in/pmfby/lms/2.jpeg",alt: "PMFBY - LMS"},
    {src: "https://pmfby.amnex.co.in/pmfby/lms/3.jpeg", alt: "PMFBY - LMS"}
  ];
  const publicCourseData = [
   { id: 1, src: 'https://pmfby.amnex.co.in/pmfby/lms/publiccourse-11.jpg', alt: 'Public Course' },
    { id: 2, src: 'https://pmfby.amnex.co.in/pmfby/lms/publiccourse-12.jpg', alt: 'Public Course' },
    { id: 3, src: 'https://pmfby.amnex.co.in/pmfby/lms/publiccourse-13.jpg', alt: 'Public Course' },
    { id: 4, src: 'https://pmfby.amnex.co.in/pmfby/lms/publiccourse-14.jpg', alt: 'Public Course' },
    { id: 5, src: 'https://pmfby.amnex.co.in/pmfby/lms/publiccourse-15.jpg', alt: 'Public Course' },
    { id: 6, src: 'https://pmfby.amnex.co.in/pmfby/lms/publiccourse-11.jpg', alt: 'Public Course' },
  ];
  return (
    <div className="min-h100">
      <Row className="justify-content-center align-items-center">
        <TopMenu/>
        <Col lg={12} sm={12} className="text-center p0">
          <div className="slider">
            {/* <Row className="slide-show"> */}
            <Carousel interval={2000} className={"myAppCarousel2"} indicators={false}>
              {carouselData.map((item, index) => (
                <Carousel.Item key={index}>
                  <img src={item.src} width='100%' alt={item.alt} className="hero-slider-img" />
                </Carousel.Item>
              ))}
            </Carousel>
            {/* </Row> */}
          </div>
        </Col>
        <Col lg={12} sm={12} className="text-center hero-slider p-relative">
          <div className="count-stats">
            <ul className="count-list">
              <li>
                <span className="icon"><RegisterUsersIcon /></span>
                <span>
                  <span className="count">{`${convertNumberToKM(metricsData?.registeredUsers)}+`}</span>
                  <span>Registered User</span>
                </span>
              </li>
              <li className="online-user-circle">
                <span className="icon"><UserIconOutline style={{color:'#ffffff', fontSize:'1.5rem'}}/>
                  <div className="blinker-homepge"></div>
                </span>
                <span>
                  <LiveUserCount onlyNumber={true}/>
                  <span>Online User</span>
                </span>
              </li>
              <li>
                <span className="icon"><CourseIcon /></span>
                <span>
                  <span className="count">{`${convertNumberToKM(metricsData?.courses)}+`}</span>
                  <span>Courses Launched</span>
                </span>
              </li>
              <li>
                <span className="icon"><TrainingIcon /></span>
                <span>
                  <span className="count">5 +</span>
                  <span>Trainings</span>
                </span>
              </li>
              <li>
                <span className="icon"><CertificateCountIcon /></span>
                <span>
                  <span className="count">{`${convertNumberToKM(metricsData?.certificatesIssued)}+`}</span>
                  <span>Certificates Issued</span>
                </span>
              </li>
               
            </ul>
          </div>
        </Col>

        <Col lg={12} className="about-lms">
          <Row className="m-4">
            <Col lg={3} md={12} className="about-imgbox">
              <img src="/lms/img/our-lms-info.svg" alt="PMFBY Logo" />
            </Col>
            <Col lg={9} md={12}>
            <a></a>
            <h1 className="about-headingtxt">Know more about our LMS</h1>
            <h4>Unfolding the Future of Learning</h4>
            <p>The Learning Management System (LMS) for Pradhan Mantri Fasal Bima Yojana (PMFBY) and Kisan Credit Card (KCC) is a pioneering initiative that aims to transform how we learn about crop insurance and agricultural credit. Through interactive and engaging video tutorials and informative resources, it seamlessly integrates e-learning with the National Crop Insurance Portal. It fulfils the vision of enhancing capacities of all stakeholders - farmers, insurance companies, financial institutions, government agencies and academic institutions - on single IT platform in a manner that makes scheme implementation more effective and uninterrupted. The detailed and interesting e-learning modules cater to the role-specific needs of the stakeholders, resolving operational issues and enhancing knowledge about the whole ecosystem of agricultural insurance and credit. The LMS is a revolutionary step, aiming to bridge the gap between policy and practice. It’s a prime tool to connect various stakeholders in PMFBY and KCC ecosystem aiming to enhance relevant knowledge and skillsets.  </p>
              <p>Ministry of Agriculture and Farmers Welfare (MoA&FW), Government of India (GoI) is implementing two major central sector flagship schemes - Pradhan Mantri Fasal Bima Yojana (PMFBY) and Modified Interest Subvention Scheme (MISS) on Kisan Credit Card (KCC). Prime objective of PMFBY is to provide simple and affordable crop insurance to protect farmers from crop loss due to unforeseen and non-preventable natural calamities.  MISS and KCC Scheme aims at providing need based and timely credit support to the farmers for their cultivation needs as well as allied activities in cost effective manner. </p>
             
              <p><a onClick={handelAbout} className="primary-linktxt" style={{'cursor':'pointer'}}>read more..</a></p>
            </Col>
          </Row>
        </Col>

        <Col lg={12} className="course-container" style={{ backgroundColor: '#e5fff3', padding: '2rem 0' }}>
          <Container>
            <Row>
              <Col lg={12}>
              <a id="courseview"></a>
                <h4>All Courses</h4>
                <p>“The Learning Management System (LMS) in e-Governance stands as a pioneering initiative under the visionary Digital India Programme, launched by the Government of India in 2015. Designed to harness the transformative power of Information Technology, this project seeks to revolutionize governance and learning by bridging the gap between policy, practice, and people.</p>
              </Col>
              <Col lg={12} >
              <SwiperCarousel clickHandeler = {handelLoginClick} data={publicCourseData} cardPerview={3} slidePerClick={1} hasNextPrev={true} playInLoop={true}/>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </div>
  );
}

export default Home;
